import * as actions from "../../../actions/user/edit";
import staffRoles from "models/staffRoles";

/**
 * The job role out of everything the user holds. A user also carries "User" and
 * "Dashboard", which are not jobs and must not land in the selector.
 */
const getBusinessRole = user => {
	if (!user || !user.roles) return "";

	const role = user.roles.find(r => staffRoles.includes(r.name));

	return role ? role.id : "";
};

const initialUserState = {
	name: "",
	lastName: "",
	email: "",
	role: "",
	generalError: "",
	roles: [],
	item: null,
	errors: {}
};

const initialState = {
	loading: false,
	...initialUserState
};

const reducer = function(state = initialState, { type, payload }) {
	switch (type) {
		case actions.SET_VALUE: {
			return {
				...state,
				...payload
			};
		}
		case actions.CLEAR_VALUE: {
			if (state.item) {
				return {
					...state,
					...initialUserState,
					roles: state.roles,
					item: state.item,
					name: state.item.name ? state.item.name : "",
					lastName: state.item.lastName ? state.item.lastName : "",
					email: state.item.email ? state.item.email : "",
					role: getBusinessRole(state.item)
				};
			}

			return {
				...state,
				...initialUserState,
				roles: state.roles
			};
		}
		case actions.GET_USER:
		case actions.EDIT_USER: {
			return {
				...state,
				loading: true
			};
		}
		case actions.GET_USER_FAILED:
		case actions.EDIT_USER_FAILED: {
			return {
				...state,
				// Without this the save button simply stopped spinning and the operator was
				// left guessing whether anything had been written.
				generalError: payload || "Não foi possível salvar o usuário",
				loading: false
			};
		}
		case actions.EDIT_USER_SUCCESS: {
			return {
				...state,
				...initialUserState,
				roles: state.roles,
				loading: false
			};
		}
		case actions.GET_USER_SUCCESS: {
			return {
				...state,
				item: payload,
				name: payload.name ? payload.name : "",
				lastName: payload.lastName ? payload.lastName : "",
				email: payload.email ? payload.email : "",
				role: getBusinessRole(payload),
				loading: false
			};
		}
		case actions.GET_ROLES_SUCCESS: {
			return {
				...state,
				roles: payload
			};
		}
		default: {
			return state;
		}
	}
};

export default reducer;
